import React from 'react';

const GhostLogin = () => {
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.split('/#')[0];
    return (
        <div>
            <iframe
                src={`${baseUrl}/intranet/ghost/`} 
                title="Ghost Login" 
                style={{ width: '100%', height: '80vh', border: 'none' }}
            ></iframe>
        </div>
    );
};

export default GhostLogin;